var priceFaceting = {
    init: function () {
        this.setListeners();
    },

    setListeners: function () {
        var $this = this;

        // Initialise les données
        if (location.pathname.match(/(prix\/)(?:\d+\-\d+)(-euros)/)) {
            var regexp = /prix\/(\d+)\-(\d+)-euros/;
            var matches = regexp.exec(location.pathname);

            $('#prixMin').val(matches[1]);
            $('#prixMax').val(matches[2]).trigger('change');
        }

        // Prévention du "Entrée" sur un des 2 champs
        $('#prixMin, #prixMax').on('keydown', function(e) {
            if (e.keyCode == 13) {
                e.preventDefault();
            }
        });

        // Soumission du mini formulaire pour le prix (btn OK)
        $('#submit-facet-prix').on('click', function (e) {
            e.preventDefault();
            $this.submitForm();
        });
    },

    submitForm: function () {
        var $block = $('.price-input');
        var $minPrice = $('#prixMin');
        var $maxPrice = $('#prixMax');
        var minPriceValue = $minPrice.val();
        var maxPriceValue = $maxPrice.val();
        var hasError = false;

        // On vérifie si le champ Prix min ne contient que des chiffres
        if (!minPriceValue.match(/^\d+$/)) {
            $minPrice.addClass('fielderror');
            hasError = true;
        }
        else {
            $minPrice.removeClass('fielderror');
        }

        // On vérifie si le champ Prix max ne contient que des chiffres
        if (!maxPriceValue.match(/^\d+$/)) {
            $maxPrice.addClass('fielderror');
            hasError = true;
        }
        else {
            $maxPrice.removeClass('fielderror');
        }

        // On vérifie si le champ min est bien inférieur au champ max
        if (!hasError && parseInt(minPriceValue) >= parseInt(maxPriceValue)) {
            $minPrice.addClass('fielderror');
            $maxPrice.addClass('fielderror');
            hasError = true;
        }

        // S'il y a eu une erreur, on s'arrête là.
        if (hasError) {
            return;
        }

        var urlToBuild = $block.find('button').data('href');

        if (urlToBuild == '') {
            urlToBuild = location.pathname;
        }

        // console.log(urlToBuild);

        // On redirige vers l'URL reconstruite avec les paramètres saisis par l'utilisateur.
        window.location.href = urlToBuild.replace(/(prix\/)(?:\d+\-\d+)(-euros)/, '$1' + minPriceValue + '-' + maxPriceValue + '$2');

        // On récupère l'URL à refabriquer
        // var urlToBuild = window.location.href;
        //
        // // On redirige vers l'URL reconstruite avec les paramètres saisis par l'utilisateur.
        // if (urlToBuild.match(/(prix\/)(?:\d+\-\d+)(-euros)/)) {
        //     window.location.href = urlToBuild.replace(/(prix\/)(?:\d+\-\d+)(-euros)/, '$1' + minPriceValue + '-' + maxPriceValue + '$2');
        // }
        // else if (urlToBuild.match(/(filtres)/)) {
        //     window.location.href = urlToBuild + '/prix/' + minPriceValue + '-' + maxPriceValue + '-euros/';
        // }
        // else {
        //     // window.location.href = urlToBuild.substring(0, urlToBuild.length - 5) + '/filtres/prix/' + minPriceValue + '-' + maxPriceValue + '-euros/';
        //     window.location.href = urlToBuild + '/filtres/prix/' + minPriceValue + '-' + maxPriceValue + '-euros/';
        // }
    }
};

(function ($) {
    priceFaceting.init();
})(jQuery);